import SparkMD5 from 'spark-md5';

const MAX_BYTES = 4096;

export const uploadFile = async (url: string, file: File, contentType: string) => {
  const base64MD5 = await md5Base64(file);
  return await new Promise<void>((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('PUT', url, true);

    xhr.setRequestHeader('Content-MD5', base64MD5);
    xhr.setRequestHeader('Content-Type', contentType);

    // TODO: Add an upload progress indicator
    xhr.upload.onprogress = () => null;

    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve();
      } else {
        reject(
          new Error(`Failed to upload ${file.name}! ${xhr.status}: ${xhr.responseText}`),
        );
      }
    };
    xhr.onerror = () => reject(new Error('Network error'));
    xhr.onabort = () => reject(new Error('Aborted'));

    xhr.send(file);
  });
};

function binaryStringToBase64(bin: string): string {
  // bin is "raw" binary string (each char code 0-255)
  return btoa(bin);
}

export async function md5Base64(
  file: File,
  chunkSize = 2 * 1024 * 1024,
): Promise<string> {
  const spark = new SparkMD5.ArrayBuffer();
  const totalChunks = Math.ceil(file.size / chunkSize);

  for (let i = 0; i < totalChunks; i++) {
    const start = i * chunkSize;
    const end = Math.min(start + chunkSize, file.size);
    spark.append(await file.slice(start, end).arrayBuffer());
  }

  const raw = spark.end(true) as unknown as string; // true => raw binary string
  return binaryStringToBase64(raw);
}

export async function generateFileChallenge(
  file: File,
  chunkSize: number = 0x8000,
): Promise<string> {
  const slice = file.slice(0, MAX_BYTES);
  const buffer = await slice.arrayBuffer();

  const bytes = new Uint8Array(buffer);

  // Convert to base64
  let binary = '';
  for (let i = 0; i < bytes.length; i += chunkSize) {
    binary += String.fromCharCode(...bytes.subarray(i, i + chunkSize));
  }

  return btoa(binary);
}
